import { Users } from '@just-in-types';
import { Reducer } from 'redux';
import { GET_MODELS, GET_VEHICLES } from '../actions/inventoryActions';
import makes from '../data/makes';

const yearMax = new Date().getFullYear();
const yearMin = 1975;

const inventoryInitialState = {
  makes,
  models: [],
  vehicles: [],
  yearMax,
  yearMin,
};

const inventoryReducer: Reducer = (
  state = inventoryInitialState,
  { type, payload },
) => {
  switch (type) {
    case GET_MODELS:
      return { ...state, models: payload };
    case GET_VEHICLES:
      return { ...state, vehicles: payload };
    default:
      return state;
  }
};

export interface IInventoryState {
  makes: string[];
  models: string[];
  vehicles: Users.Vehicle[];
  yearMax: number;
  yearMin: number;
}

export default inventoryReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/inventoryReducer.ts